import CanvasInputListenerModeEnum from "../enums/CanvasInputListenerModeEnum";
import CommandIdEnum from "../enums/CommandIdEnums";
import CommandStack from "../logic/CommandStack";
import ICanvasInputListener from "../logic/ICanvasInputListener";
import Document from "../model/document/Document";
import GeometryMoveEditCmd from "./GeometryMoveEditCmd";
import { Vector3 } from "three";

/**
 * Constrains movement to the axis defined by the edit handle's `direction` field.
 * The cursor is raycasted against a camera-facing plane, then the resulting delta
 * is projected onto the direction axis.
 */
export default class GeometryDirectionalMoveCmd extends GeometryMoveEditCmd {

    constructor(
        commandStack: CommandStack,
        canvasInputListener: ICanvasInputListener,
        document: Document,
    ) {
        super(commandStack, canvasInputListener, document);
        this.id = CommandIdEnum.GeometryDirectionalMove;
        this.commandNameResourceKey = 'command.geometryDirectionalMove.title';
        this.initialPrompResourceKey = 'command.geometryDirectionalMove.prompt';
    }

    protected override setupRaycastTarget(): void {
        this.canvasInputListener.setTargetPlaneFromCamera(this.editHandleData.position);
        this.canvasInputListener.setRaycastMode(CanvasInputListenerModeEnum.RAYCAST_PLANE);
    }

    // This command already constrains movement to a fixed axis; reference-axis snapping is not needed.
    override activate(): void {}

    override deactivate(): void {}

    protected override getSnapTargetPoint(point: Vector3): Vector3 {
        return point;
    }

    protected override computeLocalDelta(worldPoint: Vector3): Vector3 {
        const localDelta = super.computeLocalDelta(worldPoint);
        const direction = this.editHandleData.direction;
        if (!direction || direction.lengthSq() < 1e-10) return localDelta;
        const axis = direction.clone().normalize();
        return axis.multiplyScalar(localDelta.dot(axis));
    }
}
